module.exports = __webpack_public_path__ + "img/智慧公厕综合监管平台V1.0.dcaaa24c.jpg";